import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import Select from '../../commonComponents/util/Select';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import { formatDateForInput, locationIsIsraeli, formatCurrency, stripCurrencyFormat } from '../../../lib/utils';
import { CampaignCategoryTypes } from '../../../lib/systemVariables';

const initialState = {
  campaign: {
    categoryId: '',
    locationId: '',
    month: '',
    year: new Date().getFullYear(),
    approverId: '',
    maxAmount: '',
    endDate: '',
  },
  campaignCategoryType: '',
  invalidMaxAmount: false,
  error: false,
  submitAttempted: false
};

export default class CreateCampaignModal extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = initialState;

    this.onChange = this.onChange.bind(this);
  }

  onChange(name, value) {
    this.setState({ campaign: { ...this.state.campaign, ...{ [name]: value } } }, () => {
      if (name === "categoryId") {
        let campaignCategoryType = '';
        if (value) {
          const categories = [...this.props.categories];
          var index = categories.map(c => c.campaignCategoryId.toString()).indexOf(value.toString());
          if (categories[index]) campaignCategoryType = categories[index].campaignType;
        }
        this.setState({
          campaignCategoryType,
          campaign: {
            ...this.state.campaign,
            month: (!campaignCategoryType || campaignCategoryType === CampaignCategoryTypes.Yearly) ? '' : this.state.month
          }
        })
      } 
    });
  }

  async onSubmit() {
    this.setState({ error: false, submitAttempted: true });

    const campaign = this.state.campaign;
    if (!campaign.categoryId || !campaign.approverId || !campaign.year || !campaign.maxAmount || !campaign.endDate || !campaign.locationId ||
      (this.state.campaignCategoryType === CampaignCategoryTypes.Monthly && !campaign.month) || this.state.invalidMaxAmount) {
      return;
    }

    await this.props.createCampaign(this.state.campaign);

    if (this.props.success) {
      this.onClose();
      this.pushRoute(`/campaigns/${this.props.campaignId}`);
    } else {
      this.setState({ error: true });
    }
  }

  onClose() {
    this.props.close();
    this.setState(initialState);
  }

  render() {
    const campaign = this.state.campaign;
    const isIsraeli = locationIsIsraeli(this.props.locations, campaign.locationId);
    return (
      <Modal modalShowing={this.props.show}>
        <div className="modal-container">
          <div className="modal new-transaction-modal large-modal">
            <div className="modal-header">
              <h4 className="page-header">Create Campaign</h4>
              <i className="icon ion-ios-close-empty" onClick={this.onClose.bind(this)}></i>
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <div className="column-half">
                  <ValidatedInput input={<Select options={this.props.categories.map(c => ({ key: c.campaignCategoryId, value: c.name }))} />}
                    label="Category" name="categoryId" value={campaign.categoryId} onChange={this.onChange}
                    required={true} showRequiredError={this.state.submitAttempted} />
                </div>
                <div className="column-half">
                  {(campaign.categoryId && this.state.campaignCategoryType === CampaignCategoryTypes.Monthly)
                    && <ValidatedInput input={<Select options={this.props.months} />}
                      label="Month" name="month" value={campaign.month} onChange={this.onChange}
                      required={true} showRequiredError={this.state.submitAttempted} />}
                </div>
              </div>
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <div className="column-half">
                  <ValidatedInput input={<Select options={this.props.locations.map(locationGroup =>
                    ({
                      key: locationGroup.groupId,
                      value: locationGroup.groupName,
                      details: locationGroup.members.map(member => `${member.city}, ${member.state}`).join('\n')
                    }))} />}
                    label="Location" name="locationId" value={campaign.locationId} onChange={this.onChange}
                    required={true} showRequiredError={this.state.submitAttempted} />
                </div>
                <div className="column-half">
                  <ValidatedInput input={<input type="text" />}
                    label="Year" name="year" value={campaign.year} onChange={this.onChange}
                    required={true} showRequiredError={this.state.submitAttempted} />
                </div>
              </div>
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <div className="column-half">
                  <ValidatedInput input={<Select options={this.props.approvers} />}
                    label="Approver" name="approverId" value={campaign.approverId} onChange={this.onChange}
                    required={true} showRequiredError={this.state.submitAttempted} />
                </div>
                <div className="column-half">
                  <ValidatedInput input={<input type="date" min={formatDateForInput(new Date())} />}
                    label="End Date" name="endDate" value={campaign.endDate} onChange={this.onChange}
                    required={true} showRequiredError={this.state.submitAttempted} />
                </div>
              </div>
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <div className="column-half">
                  <ValidatedInput input={<CurrencyFormatInput isIsraeli={isIsraeli} />}
                    label="Max Amount" name="maxAmount" value={campaign.maxAmount} onChange={this.onChange}
                    required={true} showRequiredError={this.state.submitAttempted}/>
                </div>
                <div className="column-half"></div>
              </div>
            </div>
            {this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
              <div className="modal-btns text-right">
                <button className="btn btn-accent" onClick={this.onClose.bind(this)}>Cancel</button>
                <button className="btn btn-primary" disabled={this.state.invalidMaxAmount}
                  onClick={this.onSubmit.bind(this)}>Submit</button>
                <FadeOutErrorMessage show={this.state.error} message={this.props.message} />
              </div>}
          </div>
        </div>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaigns/CreateCampaignModal.jsx